/* global pulseWidget */
(function f($) {
    const { subscribe, a } = pulseWidget || { subscribe: false, a: '' };
    const IS_TOUCH_DEVICE  = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
    const WIDGET           = $('.subscribe-widget');
    const LATER_BTN        = $('.subscribe-widget__later');
    const WIDGET_CONTAINER = $('.subscribe-widget__container');
    const FORM             = $('#mailChimp-form');

    const getWidgetLater = () => localStorage.getItem('widgetLater');
    const setWidgetLater = () => localStorage.setItem('widgetLater', true);
    const showWidget = (firstTime = false) => {
        WIDGET.addClass('active');
        if (firstTime)
            WIDGET_CONTAINER.addClass('active');
    };
    const hideWidget = () => {
        WIDGET.removeClass('active');
        WIDGET_CONTAINER.removeClass('active');
    };

    FORM.on('click', setWidgetLater);

    // Show widget
    WIDGET.on('mouseenter', () => {
        if (!IS_TOUCH_DEVICE)
            showWidget();
    });

    // Remove Bounce Animation on Widget
    WIDGET.on('click', () => {
        // If widget is not yet active open it
        if (!WIDGET.hasClass('active')) {
            showWidget();
            return;
        }

        // Open Subscribe Modal since the widget is already active
        // window.openSubscribeModal();
        setTimeout(hideWidget, 200);
    });

    // Toggle Widget Active/Hidden State
    LATER_BTN.on('click', (e) => {
        e.stopPropagation();
        hideWidget();
        setWidgetLater();
    });

    /**
     * Use the popup events to trigger actions,
     * This looks like it triggers for all popups but we only have
     * the one so it should be fine.
     */
    window.addEventListener('us.wpopup.afterHide', setWidgetLater);

    function init() {
        // Show widget if subscribe flag or if local storage is present.
        if (subscribe || a)
            showWidget();
        else if (getWidgetLater())
            hideWidget();
        else
            showWidget(1);

        if (a === 'subscribe')
            window.openSubscribeModal(); // Defined on script.js
    }

    $(init);
}(jQuery));
